import { render, staticRenderFns } from "./PartnerWorkerAddStaff.vue?vue&type=template&id=281b7236&"
import script from "./PartnerWorkerAddStaff.vue?vue&type=script&lang=js&"
export * from "./PartnerWorkerAddStaff.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWorkerAddStaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports